<div class="modal-container d-flex flex-column h-auto">
<div class="modal-header border-0">
  <h1 class="text-primary-color">{{ CompnayID != undefined ? editName :  headingsNames}}</h1>
</div>
<div class="modal-body flex-grow-1 overflow-y-auto overflow-x-hidden pe-2"
  [ngClass]="{'invalidBothHeight': generalInformationComponent?.isEmailInvalid && generalInformationComponent?.isWebsiteInvalid,
              'invalidHeight': (generalInformationComponent?.isEmailInvalid || generalInformationComponent?.isWebsiteInvalid) && !(generalInformationComponent?.isEmailInvalid && generalInformationComponent?.isWebsiteInvalid)}">
  <tabset #tabset>
    <tab
      (selectTab)="onTabChange($event)"
      heading="General Information"
     >
      <app-general-information
        #generalInfo
        [items]="stagesName"
        [comID]="CompnayID"
        [headingNames]="headingsNames"
        [getEditName]="editName"
        >
      </app-general-information>
    </tab>
    <tab
      (selectTab)="onTabChange($event)"
      heading="Address Information"
     >
      <app-address-information #addressInfo [addressHeading]="headingsNames"></app-address-information>
    </tab>
    <tab
      (selectTab)="onTabChange($event)"
      heading="Details"
     >
      <app-details #detailInfo [headName]="headingsNames" [data]="insertUpdateGeneralInfoCompanys"  [comID]="CompnayID" ></app-details>
    </tab>
    <tab
      (selectTab)="onTabChange($event)"
      heading="Contact Information"
    >
      <app-contact-information #contactInfo [contactHeadName]="headingsNames"></app-contact-information>
    </tab>
  </tabset>
</div>
<div class="modal-footer border-0">
  <div class="d-flex m-0 gap-3">
    <app-button
      [buttonType]="'button'"
      [button_2]="true"
      [buttonClass]="'button popup-button button-danger font-14'"
      (click)="resetId();activeModal.close({isSuccess: false})"
      [buttonLable]="enumButtonName.CANCEL">
    </app-button>
    <app-button
      [buttonType]="'button'"
      [button_2]="true"
      (click)="nextTabs()"
      [buttonLable]="enumButtonName.NEXT"
      [buttonClass]="nextTab == true ? 'button popup-button button-primary font-14' : 'button popup-button button-info font-14'"
      *ngIf="tab4Disabled">
    </app-button>
    <app-button
      [buttonType]="'submit'"
      [button_2]="true"
      (click)="insertUpdateCompanyData(CompnayID != undefined ? UpdateValue : headingsNames)"
      [buttonClass]="'button popup-button button-primary font-14'"
      [buttonLable]=" CompnayID != undefined  ? UpdateValue : headingsNames"
    >
    </app-button>
  </div>
</div>
</div>